<script>

    import { toast } from 'bulma-toast'
    import { userStore, notificationsStore, modalStore } from '../stores'
    
    import NotificationsService from '../$services/notifications.service.js'

    import DateMethod from '../$methods/date.method.js'

    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let loading = false

    getNotifications()

    async function getNotifications() {

        loading = true
        const resp = await NotificationsService.getNotifications($userStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notificationsStore.set(resp.data.user)
    }

</script>

<Table items={$notificationsStore.length} {loading}>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column is-narrow">
                <div>
                    <ButtonModal modalId="notification_create_modal" text="Agregar" icon="plus" />
                </div>
            </div>
        </div>
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Tema</th>
            <th class="has-text-right">Fecha</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $notificationsStore as notification, index}
            <tr>
                <td>{index + 1}</td>
                <td>{notification.subject}</td>
                <td class="has-text-right">{DateMethod.dateTimeLarge(notification.created)}</td>
                <td>
                    <Button on:click={() => modalStore.open('notification', 'modal', notification)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>